'use client';
import { z } from 'zod';

const MAX_FILE_SIZE = 10000000;
const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

const submitApplicationSchema = z.object({
   card_photo: z
      .any()
      .refine(file => file?.length, 'Card photo is required')
      .refine(file => file?.[0]?.size <= MAX_FILE_SIZE, `Max file size is 10MB.`)
      .refine(file => ACCEPTED_IMAGE_TYPES.includes(file?.[0]?.type), 'Only .jpg, .jpeg, .png formats are supported.'),
   summary_care: z
      .any()
      .refine(file => file?.length, 'Summary care is required')
      // .optional()
      .refine(file => !file?.length || file?.[0]?.size <= MAX_FILE_SIZE, `Max file size is 10MB.`)
      .refine(
         file => !file?.length || ACCEPTED_FILE_TYPES.includes(file?.[0]?.type),
         'Only .jpg, .jpeg, .png formats are supported.',
      ),
   medical_certificate: z
      .any()
      .optional()
      .refine(file => !file?.length || file?.[0]?.size <= MAX_FILE_SIZE, `Max file size is 10MB.`)
      .refine(
         file => !file?.length || ACCEPTED_IMAGE_TYPES.includes(file?.[0]?.type),
         'Only .jpg, .jpeg, .png formats are supported.',
      ),
   qualifying_condition: z.string().trim().min(1, 'Qualifying condition is required'),
});

export type TSubmitApplication = z.infer<typeof submitApplicationSchema>;
export { submitApplicationSchema };
